<template>
  <div
    style="
      width: 2481px;
      height: 3508px;
      background: url(/static/img/CbryCert.jpg);
      margin: 0 auto;
      text-align: unset;
    "
    id="mainboy"
  >
    <div
      class="text"
      :style="`left: 0px;top: 757px; position: relative;width: 2481px;text-align: center;font-weight: bolder;line-height: 148px;height:295px;font-family: STZhongsong;font-size: ${(cert.certname.length>15||cert.certnametwo.length>15)?'105px':'128px'}`"
    >
      <p >{{ cert.certname }}</p>
	  <p v-if="cert.certnametwo">{{ cert.certnametwo }}</p>
    </div>
    <div
      class="text"
      style="left: 0px;top: 828px;position: relative;width: 2481px;color: rgb(255, 17, 0);text-align: center;font-size: 131px;font-weight: bolder;font-family: STZhongsong;"
    >
      <p>{{ cert.type=='cb'?'参编人证书':"主编人证书" }}</p>
    </div>
	<div style="left: 0px;
    top: 933px; position: relative;text-align: center;">
      <img
        :src="`/uploads/xlsfile/usepic/${cert.picsrc}?t=${Math.random()}`"
        width="470px"
        height="680px"
      />
    </div>
	<div
      class="text"
      style="left: 354px; top: 1065px; position: relative; width: 1320px; font-size: 58px; text-align: left;"
    >
      <p><span style="  letter-spacing: 23px;">姓&nbsp;&nbsp;&nbsp;&nbsp;名</span>：{{ cert.name }}</p>
    </div>
	<div
      class="text"
      style="left: 354px; top: 1122px; position: relative; width: 1320px; font-size: 58px; text-align: left;"
    >
      <p><span style="  letter-spacing: 23px;">姓&nbsp;&nbsp;&nbsp;&nbsp;别</span>：{{ cert.sex }}</p>
    </div>
	<div
      class="text"
      style="left: 354px; top: 1173px; position: relative; width: 1320px; font-size: 58px; text-align: left;"
    >
      <p><span>出生日期</span>：{{ cert.birthday }}</p>
    </div>
    <div
      class="text"
      style="left: 354px; top: 1229px; position: relative; width: 1500px;"
    >
      <p><span>身份证号</span>：{{ cert.cardid }}</p>
    </div>
	 <div
      class="text"
      style="left: 354px; top: 1283px; position: relative; width: 3000px;"
    >
      <p><span>任职单位</span>：{{ cert.danwei||'' }}</p>
    </div>
    
    <div
      class="text"
      style="left: 643.9px;top: 1620px;position: relative;width: 1205px;font-size: 58px;"
    >
      <p><span style="letter-spacing: 3px;">证书编号</span>：{{ cert.code }}</p>
    </div>
	 <div
      class="text"
      style="left: 643.9px;top: 1664px;position: relative;width: 1505px;font-size: 58px;"
    >
      <p><span style="letter-spacing: 7px;">标&nbsp;准&nbsp;号</span>：{{ cert.certcode }}</p>
    </div>
    <div :style="`left: 329.9px;top: 1410px;position: relative;width: 270px;font-size: 36px;text-align: left;`">
      <img src="/static/img/querycode.png"/>
    </div>
  </div>
</template>

<script>

// import QRCode from "qrcodejs2";
// import VueQr from 'vue-qr'
export default {
  data() {
    return {
      cert: {level:""},
      global,
      company: "XXXXXXXXXXXXXXXX",
      socilacredit: "XXXXXXXXXXXXXXXXXX",
      smallflag: false,
      fontSize:48,
      codeUrl:""
    };
  },
  components: {},
  created(){
    this.cert = this.$route.query;
    if(this.cert.danwei==='null')this.cert.danwei=' '
    console.log("cert is ",this.cert);
	// this.cert={
	// 	certname:'室内（车内）环境污染净化治理工程/施工服务企业能力等级评审指导标准',
	// 	type:'cb',
	// 	name:'周宜君',
	// 	sex:'男',
	// 	birthday:'1987年12月4日',
	// 	cardid:'421022198712043919',
	// 	danwei:'南京市有害生物防制协会',
	// 	code:'12345678',
	// 	certcode:'O/ZC077-2022'
	// }
	let position = this.cert.certname.indexOf('/');
	if (position>-1) {
		this.cert.certnametwo = this.cert.certname.slice(position+1);
		this.cert.certname = this.cert.certname.slice(0,position);
	}
    // this.codeUrl= `http://www.cnbz.org.cn/certResult?code=${this.cert.code}&name=${this.cert.name}`
  },
  methods: {
  },
  mounted() {
    
    // this.creatQrCode(this.cert.code, this.cert.name);
  },
};
</script>

<style scoped>
.positiontext {
  text-align: center;
  font-size: 48px;
  font-family: STZhongsong;
  font-weight: 900;
}
.leveltext {
  text-align: center;
  font-size: 48px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.text {
  text-align: left;
  font-size: 58px;
  /* font-family: STZhongsong; */
}
.companytext {
  text-align: center;
  font-size: 27px;
  font-family: STZhongsong;
  font-weight: 900;
}
.companytextsmall {
  text-align: center;
  font-size: 18px;
  font-family: STZhongsong;
  font-weight: 900;
}
.companyposit
{
  left: -3px; top: 60px; position: relative; width: 794px
}
.companypositsmall
{
  left: -3px; top: 81px; position: relative; width: 794px
}
.soltext {
  text-align: center;
  font-size: 18.5px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.soltextsmall {
  text-align: center;
  font-size: 20px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.soltpositsmall
{
  left: -1px; top: 62px; position: relative; width: 794
}
.soltposit{
  left: -1px; top: 33px; position: relative; width: 794
}
.text1 {
  text-align: center;
  font-size: 35px;
  font-family: STZhongsong;
}
.text2 {
  text-align: left;
  font-size: 20px;
  font-family: STZhongsong;
}
.qrcode {
  display: inline-block;
}
.qrcode /deep/ canvas img {
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}

/*
    /createCert?name=王章伟&sex=男&birthday=2021年02月23日&cardtid=340825199508021014&position=软件工程师&level=高级&code=123456&certtime=021年02月23日&picsrc=202006282342320.jpeg
*/
.textchang{
text-align: center;
    font-size: 30px;
    font-family: STZhongsong;
    line-height: 62px;
}
.text span{
  letter-spacing: 24px;
    font-size: 56px;
}
</style>
